import ContentShare from '@components/ContentShare';
import RemoteVideo from '@components/RemoteVideo';
import { VideoGrid } from '@components/VideoGrid';
import type { BaseComponentProps } from '@interfaces/selection';
import { useContentShareState } from '@providers/ContentShareProvider';
import { useRemoteVideoTileState } from '@providers/RemoteVideoTileProvider';
import { useRosterState } from '@providers/RosterProvider';
import { type FC, type PropsWithChildren } from 'react';
import { Container } from './style';

interface InterviewerVideoTileGridProps extends BaseComponentProps {}

const InterviewerVideoTileGrid: FC<
  PropsWithChildren<InterviewerVideoTileGridProps>
> = ({ ...rest }) => {
  const { tileId: contentTileId } = useContentShareState();

  const { roster, attendees } = useRosterState();
  const { tiles, tileIdToAttendeeId } = useRemoteVideoTileState();

  const videoEls = tiles.slice(0, 5);

  const getInterviewer = (tileId: number) => {
    const attendee = roster[tileIdToAttendeeId[tileId]] || {};
    const name = attendees.find(
      (dto) => dto.key === attendee?.externalUserId,
    )?.name;

    console.log('getInterviewer:', attendee, attendees);

    return {
      name: name,
      attendeeId: attendee?.chimeAttendeeId,
    };
  };

  const getVideoEls = () => {
    const els = videoEls.filter((tileId) => {
      const attendeeId = getInterviewer(tileId).attendeeId;
      return !!attendeeId;
    });

    return els.map((tileId) => {
      return (
        <RemoteVideo
          {...rest}
          key={tileId}
          size={els.length}
          tileId={tileId}
          {...getInterviewer(tileId)}
        />
      );
    });
  };

  return (
    <Container>
      {contentTileId && <ContentShare className='content-share' />}
      <VideoGrid {...rest} shared={!!contentTileId}>
        {getVideoEls()}
      </VideoGrid>
    </Container>
  );
};

export default InterviewerVideoTileGrid;
